import { useCallback } from 'react'

import { PlainInputSearch } from 'app/common/ui/PlainInput'
import useDebouncedSearch from 'app/common/hooks/useDebouncedSearch'

type Props = {
  onChangeSearch: (search: string) => void
}

export const DishesSearch = ({ onChangeSearch }: Props) => {
  const handleReset = useCallback(() => onChangeSearch(''), [onChangeSearch])

  const [searchString, handleSearch, handleClearSearch] = useDebouncedSearch(
    onChangeSearch,
    handleReset,
  )

  return (
    <PlainInputSearch
      searchString={searchString}
      handleSearch={handleSearch}
      handleClearSearch={handleClearSearch}
    />
  )
}
